import { render, staticRenderFns } from "./CardAtualizacoesTipoCliente.vue?vue&type=template&id=591e1c09&scoped=true&"
import script from "./CardAtualizacoesTipoCliente.vue?vue&type=script&lang=js&"
export * from "./CardAtualizacoesTipoCliente.vue?vue&type=script&lang=js&"
import style0 from "./CardAtualizacoesTipoCliente.vue?vue&type=style&index=0&id=591e1c09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591e1c09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardText,VCol,VProgressCircular,VRow,VSkeletonLoader})
